import { Tables } from '../../../../../../modules/API/Tables/Tables'
import { ITableDataProvider } from '../../../../../../generic/universal-table/types/data-provider.types'
import { customerTableAdapter } from '../adapters/customerTable.adapter'
import {
  CustomerCreatePayload,
  CustomerUiRow,
  CustomerUpdatePayload,
} from '../types/customerTable.types'

export const customerTableService: ITableDataProvider<
  CustomerUiRow,
  CustomerCreatePayload,
  CustomerUpdatePayload
> = {
  getList: async (): Promise<CustomerUiRow[]> => {
    const rows = await Tables.getCustomerList()
    return rows.map(customerTableAdapter.fromApi)
  },

  create: async (payload: CustomerCreatePayload): Promise<CustomerUiRow> => {
    const created = await Tables.createCustomer(payload)
    return customerTableAdapter.fromApi(created)
  },

  update: async (
    id: number | string,
    payload: CustomerUpdatePayload
  ): Promise<CustomerUiRow> => {
    const updated = await Tables.updateCustomer(Number(id), payload)
    return customerTableAdapter.fromApi(updated)
  },

  remove: async (id: number | string): Promise<void> => {
    await Tables.deleteCustomer(Number(id))
  },
}
